import { useEffect } from 'react';
import { useAppContext, APP_PAGE_STORAGE_KEY } from '../../../contexts/AppContext';
import { useAuth } from '../../../contexts/AuthContext';
import { isSuperadminPage } from '../../../utils/routeUtils';
import { useIsSuperadmin } from './useIsSuperadmin';

/**
 * Keeps non-superadmin users off superadmin routes (localStorage restore, deep links, focus sync).
 * Authorization remains on Edge Functions — this is UX only.
 */
export function useSuperadminPageGuard(): void {
  const { currentPage, setCurrentPage } = useAppContext();
  const { isAuthLoading } = useAuth();
  const { isSuperadmin, isLoading: isSuperadminLoading } = useIsSuperadmin();

  useEffect(() => {
    if (isAuthLoading || isSuperadminLoading) return;
    if (isSuperadmin || !isSuperadminPage(currentPage)) return;

    setCurrentPage('dashboard');
    try {
      localStorage.setItem(APP_PAGE_STORAGE_KEY, 'dashboard');
    } catch {
      /* ignore quota errors */
    }
  }, [
    currentPage,
    isSuperadmin,
    isAuthLoading,
    isSuperadminLoading,
    setCurrentPage,
  ]);
}
